import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { FiDocumentTemplateViewComponent } from '@fi-app/document-template/document-template-view/document-template-view.component';
import { FiDocumentTemplateStatesResolvePageTitle } from '@fi-app/document-template/states/resolve/page-title';
import { FiDocumentTemplateStatesResolveTemplate } from '@fi-app/document-template/states/resolve/template';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

export const FiDocumentTemplateViewState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Template.View,
    url: '/View/:Id?{:highlightText}',
    views: {
        '@': {
            component: FiDocumentTemplateViewComponent,
        },
    },
    resolve: {
        template: FiDocumentTemplateStatesResolveTemplate,
        pageTitle: FiDocumentTemplateStatesResolvePageTitle,
        highlightText: [
            FiStateService,
            Transition,
            (fiStateService: FiStateService, tr: Transition) => {
                return fiStateService.getParams(tr).highlightText;
            },
        ],
    },
};
